<template>
  <div id="app" @click="closeAll"   @mousemove="resetTimer" @keypress="resetTimer">
<!--    <transition name="fade" mode="out-in">-->
<!--      <router-view></router-view>-->
      <router-view style="width: 100%;height: 100%"/>
<!--    </transition>-->
<!--    <router-view></router-view>-->
    <div class="warning_voice">
      <audio id="audioMusic" class="audio" src="../src/assets/mp3/interface.mp3" controls  :hidden="true" ref="audioMusic"></audio>
      <audio id="newTask" class="audio" src="../src/assets/mp3/newTask.mp3" controls  :hidden="true" ref="newTask"></audio>
    </div>

    <!-- 多段账号权限改变提示dialog -->
    <el-dialog :close-on-click-modal="false" title="" :visible.sync="dialogVisible" width="30%" top="35vh">
      <div style="margin-top: 24px">The permission under this account has been updated. Please re-login.</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onlickLogout">OK</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
import EventBus from './ws/eventBus'
import store from "@/store/index";
import router from "@/router/router";
export default {
  name: 'App',
  data(){
    return{
      inactivityTimer: null,
      inactivityTime:  3*60 * 1000, // 5分钟，可以根据需要调整
    }
  },
  created() {
    //消息通知提示音
    EventBus.$on('updateRemindRing',()=>{
      this.$refs.audioMusic.play()
    })
    //新任务提示音
    EventBus.$on('newTaskCome',()=>{
      if(document.getElementById('newTask').onplay){
        return
      }
      const audioDom = document.querySelector('.warning_voice audio')
      audioDom && audioDom.click() // 【主要代码 - 解决报错】先模拟与页面进行交互，防止报错

      document.getElementById('newTask').play().then(() => {
      }).catch((e) => {
      });
    })
  },
  mounted() {
    let login_type =JSON.parse(localStorage.getItem('userInfo')).type
    if (login_type == 0 || login_type){
      this.$WebSocket.startWs()
    }


    this.resetTimer()
    window.addEventListener('scroll', this.resetTimer)
  },
  methods:{
    resetTimer() {
      clearTimeout(this.inactivityTimer)
      this.inactivityTimer = setTimeout(this.refreshPage, this.inactivityTime)
    },
    refreshPage() {
      if (this.$route.path == '/Dispatch') {
        window.location.reload()
      }
    },


    closeAll(){
      // EventBus.$emit('closeAll')
    },
    onlickLogout(){
      store.commit("changeGlobalDialogStatus",false);
      // localStorage.removeItem("token");
      // this.logout();
    },
    logout() {
      router.push("/login");
    },
  },
  destroyed() {
    EventBus.$off('updateRemindRing')
    EventBus.$off('newTaskCome')
  },
  beforeDestroy() {
    clearTimeout(this.inactivityTimer)
    window.removeEventListener('scroll', this.resetTimer)
  },
  computed: {
    dialogVisible() {
      return store.state.globalDialogTag;
    },
  }
}
</script>

<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
}
</style>

<style scoped lang="less">
    // /deep/
    .el-dialog__wrapper {
        background-color: #8F96A0;
    }
</style>

